import type { Recording } from './types'

export function archiveFallback(recording: Recording): Recording | null {
  const archive = recording.archive
  if (
    recording.playbackKind === 'archive' ||
    !archive ||
    archive.videoUrl === recording.videoUrl
  )
    return null
  return {
    ...recording,
    videoUrl: archive.videoUrl,
    mediaStart: archive.mediaStart,
    mediaEnd: archive.mediaEnd,
    duration: archive.duration,
    codec: archive.codec,
    playbackKind: 'archive',
    hasAudio: archive.hasAudio ?? false,
    prepared: true,
    analysisMediaStart: recording.analysisMediaStart ?? recording.mediaStart,
    analysisMediaEnd: recording.analysisMediaEnd ?? recording.mediaEnd,
  }
}

export function analysisTimeline(recording: Recording): Recording {
  return {
    ...recording,
    mediaStart: recording.analysisMediaStart ?? recording.mediaStart,
    mediaEnd: recording.analysisMediaEnd ?? recording.mediaEnd,
  }
}
